/* THIS FILE IS GENERATED. DO NOT EDIT */

import { PropsFromComponent } from '@/types/component';
import { withDebugMetadata } from '@/utils/withDebugMetadata';
import { withLabradorInstanceof } from '@/utils/withInstanceofProp';
import { LabradorTwitter as ResolvedLabradorTwitter } from 'base/components/labrador/Twitter';

export const LabradorTwitter: typeof ResolvedLabradorTwitter = withLabradorInstanceof((props) => {
    return <ResolvedLabradorTwitter {...props} {...withDebugMetadata({type: props.type, meta: props.meta})} />;
});

export type LabradorTwitterProps = PropsFromComponent<typeof LabradorTwitter>;
